// File: frontend/src/components/utility/EmptyState.js

import React from 'react';
import styles from './EmptyState.module.css';

const EmptyState = ({ 
  icon: Icon, 
  title, 
  description, 
  action = null 
}) => {
  return (
    <div className={styles.emptyState}>
      {Icon && (
        <div className={styles.iconContainer}>
          <Icon size={48} strokeWidth={1.5} />
        </div>
      )}
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};

export default EmptyState;